import styled from "styled-components";
export const TagTitle = styled.div`
    width: 100%;
    font-size: 24px;
    font-weight: 700;
    margin: 12px 0 0;
`;
